/**
 * Voice Synthesis Service
 * Uses user's voice for text-to-speech AI responses
 */

export const voiceService = {
  /**
   * Speak text using browser's Web Speech API
   * Can be enhanced with ElevenLabs for custom voice cloning
   */
  async speak(text, options = {}) {
    return new Promise((resolve, reject) => {
      // Check browser support
      const SpeechSynthesisUtterance = window.SpeechSynthesisUtterance || window.webkitSpeechSynthesisUtterance
      if (!SpeechSynthesisUtterance) {
        console.warn('Speech Synthesis not supported in this browser')
        reject(new Error('Speech Synthesis API not available'))
        return
      }

      const utterance = new SpeechSynthesisUtterance(text)

      // Configure voice parameters
      utterance.rate = options.rate || 1.0
      utterance.pitch = options.pitch || 1.0
      utterance.volume = options.volume || 1.0

      // Try to use a natural sounding voice
      const voices = window.speechSynthesis.getVoices()
      if (voices.length > 0) {
        // Prefer a natural voice
        const naturalVoice = voices.find(v => v.name.includes('Google') || v.name.includes('Natural')) || voices[0]
        utterance.voice = naturalVoice
      }

      utterance.onend = () => resolve()
      utterance.onerror = (error) => reject(error)

      window.speechSynthesis.speak(utterance)
    })
  },

  /**
   * Stop current speech
   */
  stop() {
    window.speechSynthesis.cancel()
  },

  /**
   * Check if speech synthesis is supported
   */
  isSupported() {
    return !!(window.SpeechSynthesisUtterance || window.webkitSpeechSynthesisUtterance)
  },

  /**
   * Get available voices
   */
  getVoices() {
    return window.speechSynthesis.getVoices()
  },
}
